import { CircleAlert } from "lucide-react";
import type { FC } from "react";

interface ErrorFormProps {
  message: string;
}

const ErrorForm: FC<ErrorFormProps> = ({ message }) => {
  return (
    <div className="flex mt-4 items-center gap-x-4 rounded-md border border-red-600 px-4 py-3 text-sm text-red-600">
      <CircleAlert className="w-4 h-4 red-600" />
      <p>{message}</p>
    </div>
  );
};

export default ErrorForm;
